class BigDropFloatingBuy extends HTMLElement {
  connectedCallback() {
    this.form = document.getElementById(this.dataset.formId);
    this.source = this.form?.querySelector('.js-product-add');
    if (!this.source) return;

    this.button = this.querySelector('[data-floating-button]');
    this.variantLabel = this.querySelector('[data-floating-variant]');
    this.product = this.closest('[data-section-type="product-single"]').querySelector('product-single');
    this.update = () => {
      const stage = this.source.querySelector('staged-action');
      const busy = stage?.classList.contains('is-doing');
      const done = stage?.classList.contains('is-done');
      this.button.disabled = this.source.disabled || busy || done;
      this.button.setAttribute('aria-busy', String(Boolean(busy)));
      this.button.textContent = busy ? 'Adding…' : done ? 'Added ✓' :
        (this.source.querySelector('staged-action-text')?.textContent || this.source.textContent).trim();
      const variant = this.product?.variant;
      this.variantLabel.textContent = variant && variant.title !== 'Default Title' ? variant.title : '';
      // Only appear once the original purchase button has scrolled above the viewport.
      this.hidden = this.source.getBoundingClientRect().bottom >= 0;
    };
    this.buy = () => {
      if (this.button.disabled) return;
      if (!this.form.reportValidity()) {
        this.form.scrollIntoView({ block: 'center' });
        return;
      }
      this.source.click();
      this.update();
    };
    this.button.addEventListener('click', this.buy);
    this.observer = new MutationObserver(() => {
      this.update();
      const error = this.form.closest('product-form')?.querySelector('.errors');
      if (error) error.scrollIntoView({ block: 'center' });
    });
    this.observer.observe(this.form, { subtree: true, childList: true, characterData: true, attributes: true });
    this.visibilityObserver = new IntersectionObserver(this.update);
    this.visibilityObserver.observe(this.source);
    window.addEventListener('scroll', this.update, { passive: true });
    window.addEventListener('resize', this.update);
    this.update();
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.visibilityObserver?.disconnect();
    this.button?.removeEventListener('click', this.buy);
    window.removeEventListener('scroll', this.update);
    window.removeEventListener('resize', this.update);
  }
}

if (!customElements.get('bigdrop-floating-buy')) {
  customElements.define('bigdrop-floating-buy', BigDropFloatingBuy);
}
